import { Button } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import Instructions from '../../components/Instructions';
import './style.scss';

const NoCard: React.FC = () => {
    return (
        <div className="no-card-root">
            <p className="tips">{__('Please read the following instructions before starting a wire withdrawal.')}</p>
            <Instructions />
            <Link
                to="/profile/bankcards/add"
                state={{
                    source: 'withdraw_manage'
                }}>
                <Button block type="primary" className="mt-4 btn-important">
                    {__('Add Wire Profile')}
                </Button>
            </Link>
        </div>
    );
};

export default NoCard;
